export const MOBILE_BREAKPOINT = 768;
export const DESKTOP_BORDER_RADIUS = "23px";
export const MOBILE_BORDER_RADIUS = "10px";
export const DEFAULT_WIDGET_WIDTH = "400px";
export const DEFAULT_WIDGET_HEIGHT = "80vh";
export const DEFAULT_IFRAME_HEIGHT = 750;
export const DEFAULT_IFRAME_WIDTH = 450;
export const SOURCES_CUT_TEXT = "SOURCES: [";
